import globalDataApi from './globalApiService.js'
import globalemployees from './globalemployees.js'

export default {
    namespaced: true,
    modules: {
      globalData: globalDataApi,
      globalemployees: globalemployees
    }
};
